import { applyDefaultReac } from '../reacondicionados/services/config';
import { admin, db } from '../common/config/Firebase';

export const SET_REAC_DATA = 'SET_REAC_DATA';
export const SET_REAC = 'SET_REAC';
export const DELETE_REAC = 'DELETE_REAC';
export const SET_REAC_LOADING = 'SET_REAC_LOADING';

const setReacData = payload => ({ type: SET_REAC_DATA, payload });
const setReac = payload => ({ type: SET_REAC, payload });
const deleteReacItem = payload => ({ type: DELETE_REAC, payload });
const setReacLoading = payload => ({ type: SET_REAC_LOADING, payload });

export const flagLoadingReac = loading => dispatch => dispatch(setReacLoading({ loading }));

const collectionReac = db.collection('reacondicionados');
const collectionParams = db.collection('params');

export const addReac = ({ data, resolve, reject }) => () => {
    addReac2(data).then(() => resolve()).catch(err => { console.error(err); if (reject) reject(err); });
};

const cleanForFirestore = obj =>
    Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined && v !== null));

export const addReac2 = async data => {
    const param = await collectionParams.doc('reacondicionados').get();
    const currentCount = (param.exists && param.data().count != null) ? param.data().count : 0;
    applyDefaultReac(data, currentCount);
    const increment = admin.firestore.FieldValue.increment(1);
    await collectionParams.doc('reacondicionados').set({ count: increment }, { merge: true });
    return collectionReac.add(cleanForFirestore(data));
};

export const getReac = () => (dispatch, getState) => {
    dispatch(setReacLoading({ loading: true }));
    collectionReac.onSnapshot({ includeMetadataChanges: true }, snapshot => {
        let dataAdd = {}, dataUpdate = {}, dataDelete = {};
        snapshot.docChanges().forEach(change => {
            if (change.type === 'added') dataAdd[change.doc.id] = change.doc.data();
            else if (change.type === 'modified') dataUpdate[change.doc.id] = change.doc.data();
            else if (change.type === 'removed') dataDelete[change.doc.id] = change.doc.data();
        });
        if (getState().reacondicionados.data.length === 0) {
            dispatch(setReacData(dataAdd));
        } else {
            Object.entries(dataAdd).forEach(([k, v]) => dispatch(setReac({ id: k, data: v })));
            Object.entries(dataUpdate).forEach(([k, v]) => dispatch(setReac({ id: k, data: v })));
            Object.entries(dataDelete).forEach(([k]) => dispatch(deleteReacItem({ id: k })));
        }
    });
};

export const updateReac = ({ data, resolve }) => () => {
    updateReac2(data).then(() => resolve());
};

export const updateReac2 = async data => {
    data.lastUpdated = new Date().getTime();
    await collectionReac.doc(data.id).set(cleanForFirestore(data));
};

export const deleteReac = ({ data, resolve }) => () => {
    collectionReac.doc(data.id).delete().then(() => resolve());
};

export const deleteReac2 = (data) => collectionReac.doc(data.id).delete();
